export default __webpack_public_path__ + "static/media/rock.df893f11.png";